import { SubtaskSourceEnum } from "@rightship-tech/common-ui/models/basic.models";

export interface VesselCorrespondence {
    name: string;
    isCustomerRFI: boolean;
    isReviewed: boolean;
    isInvitation: boolean;
    subtaskId: number;
    isInternal: boolean;
    parentSubtaskId?: number;
    entityTypeId: number;
    subtaskGuid: string;
    date: Date;
    subtaskStatusId: number;
    vetTaskIds: number[];
    subtaskTypeIds: number[];
    subtaskStatus: string;
    subtaskStatusDate: Date;
    type: string;
    typeDisplayText: string;
    id: number;
    additionalDetails: string;
    subject: string;
    latestSenderEmail: string;
    latestConversaionSummary: string;
    unreadMessageCount: number;
}

export interface GetCorrespondenceResponse {
    subtaskId: number;
    subtaskStatusId: number;
    guid: string;
    modifiedBy: string;
    modifiedOn: Date;
    vesselName: string;
    isInvitation?: boolean;
    vesselImo: string;
    description: string;
    requestorName: string;
    correspondence: CorrespondenceClientModel[];
    subtaskStatusHistory: SubtaskStatusHistoryClientModel[];
    entityTypeId?: number;
    subject?: string;
    isCloseout: boolean;
    closeoutAttachmentTypeId?: number;
    isRightShipAlerted?: boolean;
}

export interface CorrespondenceClientModel {
    user: string;
    createdDate: Date;
    message: string;
    isFromRightShip: boolean;
    subtaskCorrespondenceId?: number;
    role: string;
    messageSenderEmail?: string;
    messageSenderEmailTypeName?: string;
    emails: SubtaskCorrespondenceEmailModel[];
    isRead?: boolean;
    readModel: SubtaskMarkAsReadClientModel;
    ignoreFromReadScrolling?: boolean;
    markedAsReadByRSUser?: boolean;
    setAsAwaitingResponse?: boolean;
    markedThreadAsCompleted?: boolean;
    statusUser?: string;
    statusDate?: Date;
}

export interface SubtaskMarkAsReadClientModel {
    subtaskCoreespondenceReadIndicatorId: number;
    isMarkAllAsRead?: boolean;
    isRead?: boolean;
    createdDate?: Date;
}

export interface SubtaskStatusHistoryClientModel {
    createdDate: Date;
    status: string;
    statusId: number;
    user: string;
    comment: string;
    subtaskStatusSourceId: SubtaskSourceEnum;
}

export interface SubtaskCorrespondenceEmailModel {
    subtaskCorrespondenceEmailId?: number;
    email: string;
    emailRecipientTypeId?: number;
    canEdit?: boolean;
    isFrom?: boolean;
    isShipManagerEmail?: boolean;
    isFromConfig?: boolean;
    isTechnicalManagerEmail?: boolean;
    isInspectingCompanyEmail?: boolean;
    isMasterEmail?: boolean;
    isAgentEmail?: boolean;
    isCorrespondenceEmail?: boolean;
    isInspectorEmail?: boolean;
    isTraineeEmail?: boolean;
    recipientType?: string;
    recipientTypeName?: string;
}

export interface CorrespondenceEmailModel {
    subtaskCorrespondenceEmailId?: number;
    email: string;
    emailRecipientTypeId?: number;
    canEdit?: boolean;
    isFrom?: boolean;
    isShipManagerEmail?: boolean;
    isFromConfig?: boolean;
    isTechnicalManagerEmail?: boolean;
    isInspectingCompanyEmail?: boolean;
    isMasterEmail?: boolean;
    isAgentEmail?: boolean;
    isCorrespondenceEmail?: boolean;
    isInspectorEmail?: boolean;
    isTraineeEmail?: boolean;
    recipientType?: string;
    recipientTypeName?: string;
}

export interface CorrespondenceReplyResponse {
    subtaskCorrespondenceId: number;
    validationResult: any;
}

export interface AddSubtaskRequest {
    entityId: number;
    entityTypeId: number;
    emails: CorrespondenceEmailModel[];
    isInternal: boolean;
    isCustomerRFI?: boolean;
    resendEmail: boolean;
    statusSnippet: string;
    comment: string;
    name?: string;
    changeStatusToAwaitingResponse: boolean;
    changeStatusToPendingReview?: boolean;
    message: string;
    orderGuid?: string;
    subtaskId: number;
    skipInvitation: boolean;
    subtaskCorrespondenceId?: number;
    submit: boolean;
    subtaskTypes: number[];
    vetTaskIds: number[];
    attachments: File[];
    files: any[];
    dataSourceId: number;
    isPriority: boolean;
    changeStatusToPendingTerminalReview?: boolean;
    subject: string;
    messageSenderEmail?: string;
    subtaskSourceId: number;
    isRightShipAlerted?: boolean;
}

export interface MessageCenterTaskModel {
    taskId: number;
    entityType: any;
    vesselName: string;
    vesselImo: number | string;
    subtaskId?: number;
    description: string;
    emailIdentifier: string;
    emailIdentifierTypeName: string;
    isShipManager: boolean;
    isInspectionCompany: boolean;
    isFreelancer: boolean;
    assignmentStatusActive: boolean;
    encryptedParams: string;
    reviseProposal: () => void;
    withdrawInspection: () => void;
    changeInspectionDate: () => void;
    cancelInspection: () => void;
    newConversationCheckboxAction: NewConversationCheckboxActionModel;
} 

export interface MessageCenterAccessModel {
    isFreelancer: boolean;
    isShipManager: boolean;
    isInspectionCompany: boolean;
    assignmentStatusActive: boolean;
    encryptedParams: string;
    allowInitNewThread: boolean;
    reviseProposal: () => void;
    withdrawInspection: () => void;
    changeInspectionDate: () => void;
    cancelInspection: () => void;
    startNewConversation: () => void;
}

export interface UpdateCorrespondenceReadIndicator {
    subtaskId: number;
    email: string;
    correspondenceReadStatuses: CorrespondenceReadStatusModel[];
}

export interface CorrespondenceReadStatusModel {
    subtaskCorrespondenceId: number;
    isRead: boolean;
}

export interface MarkAllAsReadRequest {
    subtaskCorrespondenceId: number;
}

export enum SubtaskStatusEnum {
    Pending = 1,
    PendingReview = 2,
    AwaitingResponse = 3,
    Closed = 6,
    Replied = 7
}

export class NewConversationCheckboxActionModel {
    text: string;
    defaultValue: boolean;
    action: (subtask: AddSubtaskRequest, value: boolean) => Promise<boolean>;
    showTooltip: boolean;
    tooltipText: string;
    isHidden: boolean;
}

export class RightshipRecipientConfigModel {
    canEditRightshipRecipient: boolean | null;
    addedRsAsRecipient: boolean;
    onRsRecipientToggle: (add: boolean) => void;
}